import InputToggle from './InputToggle';

export default InputToggle;
